import React from "react";
import {InvitationFormContainer} from "../../../components/apps/public/confirm-invitation/InvitationForm.container";

const ConfirmInvitationPage = () => <InvitationFormContainer/>

export default ConfirmInvitationPage;
